import { styled } from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  color: var(--mainTextColor);

  img {
    width: 400px;
  }

  h1 {
    font-size: 1.5rem;
  }
`;
